import React from 'react';
import { GatsbyImage as Img, GatsbyImageProps } from 'gatsby-plugin-image';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

type MobileImageProps = {
  mobileProps?: {
    ratio?: number;
    mediaQuery: string;
  };
};

const StyledGatsbyImage = styled(Img, {
  shouldForwardProp: (prop) => prop !== 'mobileProps',
})(
  ({ mobileProps }: MobileImageProps) => css`
    ${mobileProps?.ratio &&
    css`
      @media ${mobileProps.mediaQuery} {
        aspect-ratio: ${mobileProps.ratio};
      }
    `}
  `,
);

const GatsbyImage = ({
  alt,
  image,
  objectFit,
  objectPosition,
  loading,
  className,
  mobileProps,
}: GatsbyImageProps & MobileImageProps) => (
  <StyledGatsbyImage
    alt={alt}
    image={image}
    objectFit={objectFit}
    objectPosition={objectPosition}
    loading={loading}
    className={className}
    mobileProps={mobileProps}
  />
);

export default GatsbyImage;
